import {Image, Pagination, Table, Tooltip} from "antd";
import {renderDate} from "../../../../utils";
import {Button, StatusLabel, Icon} from "../../../../components";
import {Link} from "react-router-dom";

function PromotionTable({items = [], pagination, onPaginationChange, can})
{
    const columns = [
        {
            title: "Mã chương trình",
            dataIndex: "code",
            key: "code",
            width: 150,
            render: (_, item) => {
                return (<Link to={`/promotion/detail/${item.id}`}>KM{item.id}</Link>)
            }
        },
        {
            title: "Ảnh chương trình",
            dataIndex: "image",
            key: "image",
            width: 150,
            render: (_, item) => {
                return (<Image src={item.image} width={50} height={50} preview={false} />)
            }
        },
        {
            title: "Tên chương trình",
            dataIndex: "name",
            key: "name",
            render: (_, item) => {
                return (<span>{item.name}</span>)
            }
        },
        {
            title: "Ngày bắt đầu",
            dataIndex: "timeStart",
            key: "timeStart",
            width: 200,
            render: (_, item) => {
                return <span>{renderDate(item.timeStart)}</span>;
            }
        },
        {
            title: "Ngày kết thúc",
            dataIndex: "timeEnd",
            key: "timeEnd",
            width: 200,
            render: (_, item) => {
                return <span>{renderDate(item.timeEnd)}</span>;
            }
        },
        {
            title: "Tình trạng",
            dataIndex: "status",
            key: "status",
            width: 120,
            render: (_, item) => {
                return <span><StatusLabel type={item.status.badge}>{item.status.label}</StatusLabel></span>;
            }
        },
        {
            title: "Người tạo",
            dataIndex: "service",
            key: "service",
            width: 200,
            render: (_, item) => {
                return <span>{item.user.firstname + ' ' + item.user.lastname}</span>;
            }
        },
        {
            title: '#',
            dataIndex: 'action',
            key: "action",
            width: '220px',
            render: (_, item) => {
                return <div className="table-action d-flex">
                    <Tooltip title="Thông tin"><Button background blue leftIcon={Icon.info} to={`/promotion/detail/${item.id}`}></Button></Tooltip>
                    {
                        can.edit && <Tooltip title="Cập nhật"><Button background blue leftIcon={Icon.edit} to={`/promotion/edit/${item.id}`}></Button></Tooltip>
                    }
                </div>
            }
        }
    ]

    const dataSource= items.map(row => ({
        key: row.id, // I added this line
        ...row
    }));

    return (
        <div className="table-wrapper">
            <div className="table-box">
                <Table columns={columns} dataSource={dataSource} scroll={{ y:550 }} pagination={false} />
            </div>
            <Pagination current={pagination.page} defaultCurrent={1} defaultPageSize={20} pageSize={pagination.limit} total={pagination.totalRows} onChange={onPaginationChange}  showSizeChanger={false} />
        </div>
    )
}

export default PromotionTable;